import cacheSystem from '@utils/cacheSystem';
import ApplicationService from './applicationService';
import ClientService from './clientService';

const INSTANCE_ERROR = { message : 'Unable to initialize the cacheSystem' };

const getOrUpdate = (key, endpoint, options) => {
	const instance = cacheSystem.getInstance();

	if (!instance) return Promise.reject(INSTANCE_ERROR);

	return instance.getOrUpdate(key, endpoint, options);
};

export const getUSStates = () => getOrUpdate('app.states', ApplicationService.getUSStates);

export const getClients = () => getOrUpdate('user.clients', ClientService.getAll);

export const getTimeZones = () => getOrUpdate('app.timeZones', ApplicationService.getTimeZones);

export const getLocationTypes = () => getOrUpdate('app.locationTypes', ApplicationService.getLocationTypes);

export default {
	getUSStates,
	getClients,
	getTimeZones,
	getLocationTypes,
};
